var map = {
	"./account_center_logo.svg": 1005,
	"./account_center_only_logo.svg": 1006,
	"./arrow_blue_right.svg": 1007,
	"./arrow_dropdown_blue.svg": 1008,
	"./arrow_left.svg": 1009,
	"./checkbox_default.svg": 1010,
	"./checkbox_selected.svg": 1011,
	"./circle_bookshelf_sm.svg": 1012,
	"./circle_bookshelf_sm_hover.svg": 1013,
	"./circle_support.svg": 1014,
	"./circle_support_hover.svg": 1015,
	"./circle_support_sm.svg": 1016,
	"./circle_support_sm_hover.svg": 1017,
	"./devices.svg": 1018,
	"./error.svg": 1019,
	"./error_icon.svg": 1020,
	"./external_window.svg": 1021,
	"./external_window_white.svg": 1022,
	"./i_icon.svg": 1023,
	"./loader.svg": 1024,
	"./logo.svg": 1025,
	"./logo_ac.svg": 1026,
	"./mobile.svg": 1027,
	"./preferences.svg": 1028,
	"./radio_button_default.svg": 1029,
	"./radio_button_selected.svg": 1030,
	"./resources.svg": 1031,
	"./sign_out.svg": 1032,
	"./sort_icon.svg": 1033,
	"./success.svg": 1034,
	"./success_icon.svg": 1035,
	"./transactions.svg": 399,
	"./user.svg": 1036,
	"./user_info.svg": 1037,
	"./vitalsource_color.svg": 1038
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1039;



/*****************
 ** WEBPACK FOOTER
 ** ./src/img ./~/svg-inline-loader?removeSVGTagAttrs=false!\.svg$
 ** module id = 1039
 ** module chunks = 0
 **/